import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import Vuex from 'vuex'
import axios from 'axios'
import yaml from 'js-yaml'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueLazyload from 'vue-lazyload'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.use(VueLazyload,  {
  lazyComponent: true
})

Vue.use(ElementUI)
Vue.use(Vuex)

if (__BROWSER__) {
  require('./app.css')
}

const createStore = () => new Vuex.Store({
  state: {
    contributors: []
  },
  mutations: {
    UPDATE_CONTRIBUTORS(state, payload) {
      state.contributors = payload
    }
  },
  actions: {
    async updateContributors({
      commit
    }, payload) {
      const data = await axios.get(`https://api.github.com/repos/airyland/vux/contributors?per_page=100`).then(res => {
        const list = res.data
        list.forEach((user, index) => {
          // my girl
          if (user.login === 'QiongrongJiang') {
            const saved = user
            list.splice(index, 1)
            list.splice(1, 0, saved)
            return
          }
        })
        return list
      })
      commit('UPDATE_CONTRIBUTORS', data)
    }
  }
})

const list = [{
  chapter: 'about',
  pages: [{
    path: 'version',
    title: '版本发布说明'
  }]
}]

// Lazy-loading (i.e. code-split) your markdown file as vue component
const routes = []

routes.push({
  path: '/',
  redirect: '/zh-CN/'
})

  routes.push({
    path: '/en/lab/index.html',
    component: () => import('../en/lab/index.md')
  })
  routes.push({
    path: '/en/faq',
    component: () => import('../en/faq/index.md')
  })
  routes.push({
    path: '/en/',
    component: () => import('../en/README.md')
  })
  routes.push({
    path: '/en/about/contributors.html',
    component: () => import('../en/about/contributors.vue')
  })
  routes.push({
    path: '/zh-CN/lab/index.html',
    component: () => import('../zh-CN/lab/index.md')
  })
  routes.push({
    path: '/zh-CN/faq',
    component: () => import('../zh-CN/faq/index.md')
  })
  routes.push({
    path: '/zh-CN/',
    component: () => import('../zh-CN/README.md')
  })
  routes.push({
    path: '/zh-CN/about/contributors.html',
    component: () => import('../zh-CN/about/contributors.vue')
  })
  routes.push({
    path: '/en/about/before-using-vux.html',
    component: () => import('../en/about/before-using-vux.md')
  })
      
  routes.push({
    path: '/en/about/showcase.html',
    component: () => import('../en/about/showcase.md')
  })
      
  routes.push({
    path: '/en/about/thanks.html',
    component: () => import('../en/about/thanks.md')
  })
      
  routes.push({
    path: '/en/changelog/2.7.6.html',
    component: () => import('../en/changelog/2.7.6.md')
  })
      
  routes.push({
    path: '/en/changelog/2.9.3.html',
    component: () => import('../en/changelog/2.9.3.md')
  })
      
  routes.push({
    path: '/en/changelog/changelog.html',
    component: () => import('../en/changelog/changelog.md')
  })
      
  routes.push({
    path: '/en/changelog/next.html',
    component: () => import('../en/changelog/next.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.0.0.html',
    component: () => import('../en/changelog/v2.0.0.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.0.1.html',
    component: () => import('../en/changelog/v2.0.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.0.14.html',
    component: () => import('../en/changelog/v2.0.14.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.0-rc.46.html',
    component: () => import('../en/changelog/v2.1.0-rc.46.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.0-rc.47.html',
    component: () => import('../en/changelog/v2.1.0-rc.47.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.0-rc.48.html',
    component: () => import('../en/changelog/v2.1.0-rc.48.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.0-rc.49.html',
    component: () => import('../en/changelog/v2.1.0-rc.49.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.0-rc.50.html',
    component: () => import('../en/changelog/v2.1.0-rc.50.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.0-rc.51.html',
    component: () => import('../en/changelog/v2.1.0-rc.51.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.0.html',
    component: () => import('../en/changelog/v2.1.0.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.1.html',
    component: () => import('../en/changelog/v2.1.1-rc.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.10.html',
    component: () => import('../en/changelog/v2.1.1-rc.10.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.11.html',
    component: () => import('../en/changelog/v2.1.1-rc.11.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.12.html',
    component: () => import('../en/changelog/v2.1.1-rc.12.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.13.html',
    component: () => import('../en/changelog/v2.1.1-rc.13.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.14.html',
    component: () => import('../en/changelog/v2.1.1-rc.14.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.2.html',
    component: () => import('../en/changelog/v2.1.1-rc.2.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.3.html',
    component: () => import('../en/changelog/v2.1.1-rc.3.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.4.html',
    component: () => import('../en/changelog/v2.1.1-rc.4.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.5.html',
    component: () => import('../en/changelog/v2.1.1-rc.5.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.6.html',
    component: () => import('../en/changelog/v2.1.1-rc.6.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.7.html',
    component: () => import('../en/changelog/v2.1.1-rc.7.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.8.html',
    component: () => import('../en/changelog/v2.1.1-rc.8.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.1.1-rc.9.html',
    component: () => import('../en/changelog/v2.1.1-rc.9.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.10.1.html',
    component: () => import('../en/changelog/v2.10.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.2.0.html',
    component: () => import('../en/changelog/v2.2.0.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.2.1-rc.1.html',
    component: () => import('../en/changelog/v2.2.1-rc.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.2.1-rc.2.html',
    component: () => import('../en/changelog/v2.2.1-rc.2.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.2.1-rc.3.html',
    component: () => import('../en/changelog/v2.2.1-rc.3.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.2.1-rc.4.html',
    component: () => import('../en/changelog/v2.2.1-rc.4.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.2.1-rc.6.html',
    component: () => import('../en/changelog/v2.2.1-rc.6.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.2.1-rc.7.html',
    component: () => import('../en/changelog/v2.2.1-rc.7.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.2.1-rc.8.html',
    component: () => import('../en/changelog/v2.2.1-rc.8.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.2.1.html',
    component: () => import('../en/changelog/v2.2.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.2.2.html',
    component: () => import('../en/changelog/v2.2.2.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.3.1.html',
    component: () => import('../en/changelog/v2.3.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.3.2.html',
    component: () => import('../en/changelog/v2.3.2.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.3.3.html',
    component: () => import('../en/changelog/v2.3.3.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.3.4.html',
    component: () => import('../en/changelog/v2.3.4.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.3.5.html',
    component: () => import('../en/changelog/v2.3.5.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.3.6.html',
    component: () => import('../en/changelog/v2.3.6.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.3.7.html',
    component: () => import('../en/changelog/v2.3.7.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.3.8.html',
    component: () => import('../en/changelog/v2.3.8.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.4.0.html',
    component: () => import('../en/changelog/v2.4.0.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.4.1.html',
    component: () => import('../en/changelog/v2.4.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.0.html',
    component: () => import('../en/changelog/v2.5.0.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.1.html',
    component: () => import('../en/changelog/v2.5.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.10.html',
    component: () => import('../en/changelog/v2.5.10.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.11.html',
    component: () => import('../en/changelog/v2.5.11.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.12.html',
    component: () => import('../en/changelog/v2.5.12.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.2.html',
    component: () => import('../en/changelog/v2.5.2.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.3.html',
    component: () => import('../en/changelog/v2.5.3.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.4.html',
    component: () => import('../en/changelog/v2.5.4.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.5.html',
    component: () => import('../en/changelog/v2.5.5.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.6.html',
    component: () => import('../en/changelog/v2.5.6.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.7.html',
    component: () => import('../en/changelog/v2.5.7.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.8.html',
    component: () => import('../en/changelog/v2.5.8.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.5.9.html',
    component: () => import('../en/changelog/v2.5.9.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.6.0.html',
    component: () => import('../en/changelog/v2.6.0.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.6.1.html',
    component: () => import('../en/changelog/v2.6.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.6.2.html',
    component: () => import('../en/changelog/v2.6.2.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.6.3.html',
    component: () => import('../en/changelog/v2.6.3.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.6.4.html',
    component: () => import('../en/changelog/v2.6.4.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.6.5.html',
    component: () => import('../en/changelog/v2.6.5.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.7.0.html',
    component: () => import('../en/changelog/v2.7.0.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.7.1.html',
    component: () => import('../en/changelog/v2.7.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.7.2.html',
    component: () => import('../en/changelog/v2.7.2.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.7.3.html',
    component: () => import('../en/changelog/v2.7.3.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.7.4.html',
    component: () => import('../en/changelog/v2.7.4.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.7.5.html',
    component: () => import('../en/changelog/v2.7.5.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.7.6.html',
    component: () => import('../en/changelog/v2.7.6.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.7.7.html',
    component: () => import('../en/changelog/v2.7.7.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.7.8.html',
    component: () => import('../en/changelog/v2.7.8.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.7.9.html',
    component: () => import('../en/changelog/v2.7.9.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.8.0.html',
    component: () => import('../en/changelog/v2.8.0.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.8.1.html',
    component: () => import('../en/changelog/v2.8.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.9.0.html',
    component: () => import('../en/changelog/v2.9.0.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.9.1.html',
    component: () => import('../en/changelog/v2.9.1.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.9.2.html',
    component: () => import('../en/changelog/v2.9.2.md')
  })
      
  routes.push({
    path: '/en/changelog/v2.9.4.html',
    component: () => import('../en/changelog/v2.9.4.md')
  })
      
  routes.push({
    path: '/en/contribution/donate.html',
    component: () => import('../en/contribution/donate.md')
  })
      
  routes.push({
    path: '/en/contribution/issue.html',
    component: () => import('../en/contribution/issue.md')
  })
      
  routes.push({
    path: '/en/contribution/pr.html',
    component: () => import('../en/contribution/pr.md')
  })
      
  routes.push({
    path: '/en/contribution/vux-development.html',
    component: () => import('../en/contribution/vux-development.md')
  })
      
  routes.push({
    path: '/en/css.html',
    component: () => import('../en/css.md')
  })
      
  routes.push({
    path: '/en/css/1px.html',
    component: () => import('../en/css/1px.md')
  })
      
  routes.push({
    path: '/en/css/close.html',
    component: () => import('../en/css/close.md')
  })
      
  routes.push({
    path: '/en/development/i18n.html',
    component: () => import('../en/development/i18n.md')
  })
      
  routes.push({
    path: '/en/development/remove-click-delay-fastclick.html',
    component: () => import('../en/development/remove-click-delay-fastclick.md')
  })
      
  routes.push({
    path: '/en/development/router.html',
    component: () => import('../en/development/router.md')
  })
      
  routes.push({
    path: '/en/development/theme.html',
    component: () => import('../en/development/theme.md')
  })
      
  routes.push({
    path: '/en/development/typescript.html',
    component: () => import('../en/development/typescript.md')
  })
      
  routes.push({
    path: '/en/development/vue-ajax.html',
    component: () => import('../en/development/vue-ajax.md')
  })
      
  routes.push({
    path: '/en/development/vue-global-method.html',
    component: () => import('../en/development/vue-global-method.md')
  })
      
  routes.push({
    path: '/en/development/vue-google-analytics.html',
    component: () => import('../en/development/vue-google-analytics.md')
  })
      
  routes.push({
    path: '/en/development/vue-loader-autoprefix.html',
    component: () => import('../en/development/vue-loader-autoprefix.md')
  })
      
  routes.push({
    path: '/en/development/vue-loader-disable-eslint.html',
    component: () => import('../en/development/vue-loader-disable-eslint.md')
  })
      
  routes.push({
    path: '/en/development/vue-router-page-transition.html',
    component: () => import('../en/development/vue-router-page-transition.md')
  })
      
  routes.push({
    path: '/en/development/vue-show-loading.html',
    component: () => import('../en/development/vue-show-loading.md')
  })
      
  routes.push({
    path: '/en/development/vue-webpack-code-splitting-async.html',
    component: () => import('../en/development/vue-webpack-code-splitting-async.md')
  })
      
  routes.push({
    path: '/en/development/vue-webpack-env.html',
    component: () => import('../en/development/vue-webpack-env.md')
  })
      
  routes.push({
    path: '/en/development/vux-nuxt-ssr.html',
    component: () => import('../en/development/vux-nuxt-ssr.md')
  })
      
  routes.push({
    path: '/en/directives/v-transfer-dom.html',
    component: () => import('../en/directives/v-transfer-dom.md')
  })
      
  routes.push({
    path: '/en/faq/$t-is-not-defined.html',
    component: () => import('../en/faq/$t-is-not-defined.md')
  })
      
  routes.push({
    path: '/en/faq/can-vux-used-in-weapp.html',
    component: () => import('../en/faq/can-vux-used-in-weapp.md')
  })
      
  routes.push({
    path: '/en/faq/cannot-resolve-inline-desc.html',
    component: () => import('../en/faq/cannot-resolve-inline-desc.md')
  })
      
  routes.push({
    path: '/en/faq/difference-between-vux-template-and-webpack-template.html',
    component: () => import('../en/faq/difference-between-vux-template-and-webpack-template.md')
  })
      
  routes.push({
    path: '/en/faq/document-framework.html',
    component: () => import('../en/faq/document-framework.md')
  })
      
  routes.push({
    path: '/en/faq/does-vux-support-weex.html',
    component: () => import('../en/faq/does-vux-support-weex.md')
  })
      
  routes.push({
    path: '/en/faq/dupicate-style.html',
    component: () => import('../en/faq/dupicate-style.md')
  })
      
  routes.push({
    path: '/en/faq/index.html',
    component: () => import('../en/faq/index.md')
  })
      
  routes.push({
    path: '/en/faq/is-vux-wechat-official-project.html',
    component: () => import('../en/faq/is-vux-wechat-official-project.md')
  })
      
  routes.push({
    path: '/en/faq/Uncaught-SyntaxError-Unexpected-token-export.html',
    component: () => import('../en/faq/Uncaught-SyntaxError-Unexpected-token-export.md')
  })
      
  routes.push({
    path: '/en/faq/vux-build-issue.html',
    component: () => import('../en/faq/vux-build-issue.md')
  })
      
  routes.push({
    path: '/en/faq/vux-server-render-support.html',
    component: () => import('../en/faq/vux-server-render-support.md')
  })
      
  routes.push({
    path: '/en/faq/what-is-vux-virtual-component.html',
    component: () => import('../en/faq/what-is-vux-virtual-component.md')
  })
      
  routes.push({
    path: '/en/faq/why-cannot-i-import-all-components.html',
    component: () => import('../en/faq/why-cannot-i-import-all-components.md')
  })
      
  routes.push({
    path: '/en/faq/why-cannot-i-use-vux-with-cdn.html',
    component: () => import('../en/faq/why-cannot-i-use-vux-with-cdn.md')
  })
      
  routes.push({
    path: '/en/faq/why-close-my-issue.html',
    component: () => import('../en/faq/why-close-my-issue.md')
  })
      
  routes.push({
    path: '/en/faq/why-delete-my-issue-comment.html',
    component: () => import('../en/faq/why-delete-my-issue-comment.md')
  })
      
  routes.push({
    path: '/en/faq/why-use-vue-file-for-distribution.html',
    component: () => import('../en/faq/why-use-vue-file-for-distribution.md')
  })
      
  routes.push({
    path: '/en/faq/why-use-x-prefix-for-components.html',
    component: () => import('../en/faq/why-use-x-prefix-for-components.md')
  })
      
  routes.push({
    path: '/en/faq/why-using-vux-loader.html',
    component: () => import('../en/faq/why-using-vux-loader.md')
  })
      
  routes.push({
    path: '/en/faq/will-vux-stop-maintaining.html',
    component: () => import('../en/faq/will-vux-stop-maintaining.md')
  })
      
  routes.push({
    path: '/en/install/biolerplate.html',
    component: () => import('../en/install/biolerplate.md')
  })
      
  routes.push({
    path: '/en/install/manual-usage.html',
    component: () => import('../en/install/manual-usage.md')
  })
      
  routes.push({
    path: '/en/install/npm.html',
    component: () => import('../en/install/npm.md')
  })
      
  routes.push({
    path: '/en/install/umd.html',
    component: () => import('../en/install/umd.md')
  })
      
  routes.push({
    path: '/en/install/upgrade-to-vux2.html',
    component: () => import('../en/install/upgrade-to-vux2.md')
  })
      
  routes.push({
    path: '/en/install/usage.html',
    component: () => import('../en/install/usage.md')
  })
      
  routes.push({
    path: '/en/lab/index.html',
    component: () => import('../en/lab/index.md')
  })
      
  routes.push({
    path: '/en/production/inline-manifest.html',
    component: () => import('../en/production/inline-manifest.md')
  })
      
  routes.push({
    path: '/en/README.html',
    component: () => import('../en/README.md')
  })
      
  routes.push({
    path: '/en/tools/base64.html',
    component: () => import('../en/tools/base64.md')
  })
      
  routes.push({
    path: '/en/tools/cookie.html',
    component: () => import('../en/tools/cookie.md')
  })
      
  routes.push({
    path: '/en/tools/date.html',
    component: () => import('../en/tools/date.md')
  })
      
  routes.push({
    path: '/en/tools/debounce-throttle.html',
    component: () => import('../en/tools/debounce-throttle.md')
  })
      
  routes.push({
    path: '/en/tools/md5.html',
    component: () => import('../en/tools/md5.md')
  })
      
  routes.push({
    path: '/en/tools/number.html',
    component: () => import('../en/tools/number.md')
  })
      
  routes.push({
    path: '/en/tools/querystring.html',
    component: () => import('../en/tools/querystring.md')
  })
      
  routes.push({
    path: '/en/tools/string.html',
    component: () => import('../en/tools/string.md')
  })
      
  routes.push({
    path: '/en/umd.html',
    component: () => import('../en/umd.md')
  })
      
  routes.push({
    path: '/en/upgrade-to-2.html',
    component: () => import('../en/upgrade-to-2.md')
  })
      
  routes.push({
    path: '/en/vux-loader.html',
    component: () => import('../en/vux-loader.md')
  })
      
  routes.push({
    path: '/en/vux-loader/about.html',
    component: () => import('../en/vux-loader/about.md')
  })
      
  routes.push({
    path: '/en/vux-loader/how-vux-loader-works.html',
    component: () => import('../en/vux-loader/how-vux-loader-works.md')
  })
      
  routes.push({
    path: '/en/vux-loader/install.html',
    component: () => import('../en/vux-loader/install.md')
  })
      
  routes.push({
    path: '/en/vux-loader/plugins.html',
    component: () => import('../en/vux-loader/plugins.md')
  })
      
  routes.push({
    path: '/en/wechat/other.html',
    component: () => import('../en/wechat/other.md')
  })
      
  routes.push({
    path: '/en/wechat/vue-wechat-jssdk.html',
    component: () => import('../en/wechat/vue-wechat-jssdk.md')
  })
      
  routes.push({
    path: '/en/wechat/wechat-document-title.html',
    component: () => import('../en/wechat/wechat-document-title.md')
  })
      
  routes.push({
    path: '/zh-CN/about/before-using-vux.html',
    component: () => import('../zh-CN/about/before-using-vux.md')
  })
      
  routes.push({
    path: '/zh-CN/about/showcase.html',
    component: () => import('../zh-CN/about/showcase.md')
  })
      
  routes.push({
    path: '/zh-CN/about/thanks.html',
    component: () => import('../zh-CN/about/thanks.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/2.7.6.html',
    component: () => import('../zh-CN/changelog/2.7.6.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/2.9.3.html',
    component: () => import('../zh-CN/changelog/2.9.3.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/changelog.html',
    component: () => import('../zh-CN/changelog/changelog.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/next.html',
    component: () => import('../zh-CN/changelog/next.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.0.0.html',
    component: () => import('../zh-CN/changelog/v2.0.0.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.0.1.html',
    component: () => import('../zh-CN/changelog/v2.0.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.0.14.html',
    component: () => import('../zh-CN/changelog/v2.0.14.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.0-rc.46.html',
    component: () => import('../zh-CN/changelog/v2.1.0-rc.46.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.0-rc.47.html',
    component: () => import('../zh-CN/changelog/v2.1.0-rc.47.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.0-rc.48.html',
    component: () => import('../zh-CN/changelog/v2.1.0-rc.48.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.0-rc.49.html',
    component: () => import('../zh-CN/changelog/v2.1.0-rc.49.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.0-rc.50.html',
    component: () => import('../zh-CN/changelog/v2.1.0-rc.50.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.0-rc.51.html',
    component: () => import('../zh-CN/changelog/v2.1.0-rc.51.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.0.html',
    component: () => import('../zh-CN/changelog/v2.1.0.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.1.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.10.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.10.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.11.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.11.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.12.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.12.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.13.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.13.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.14.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.14.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.2.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.2.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.3.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.3.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.4.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.4.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.5.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.5.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.6.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.6.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.7.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.7.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.8.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.8.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.1.1-rc.9.html',
    component: () => import('../zh-CN/changelog/v2.1.1-rc.9.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.10.1.html',
    component: () => import('../zh-CN/changelog/v2.10.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.2.0.html',
    component: () => import('../zh-CN/changelog/v2.2.0.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.2.1-rc.1.html',
    component: () => import('../zh-CN/changelog/v2.2.1-rc.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.2.1-rc.2.html',
    component: () => import('../zh-CN/changelog/v2.2.1-rc.2.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.2.1-rc.3.html',
    component: () => import('../zh-CN/changelog/v2.2.1-rc.3.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.2.1-rc.4.html',
    component: () => import('../zh-CN/changelog/v2.2.1-rc.4.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.2.1-rc.6.html',
    component: () => import('../zh-CN/changelog/v2.2.1-rc.6.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.2.1-rc.7.html',
    component: () => import('../zh-CN/changelog/v2.2.1-rc.7.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.2.1-rc.8.html',
    component: () => import('../zh-CN/changelog/v2.2.1-rc.8.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.2.1.html',
    component: () => import('../zh-CN/changelog/v2.2.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.2.2.html',
    component: () => import('../zh-CN/changelog/v2.2.2.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.3.1.html',
    component: () => import('../zh-CN/changelog/v2.3.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.3.2.html',
    component: () => import('../zh-CN/changelog/v2.3.2.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.3.3.html',
    component: () => import('../zh-CN/changelog/v2.3.3.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.3.4.html',
    component: () => import('../zh-CN/changelog/v2.3.4.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.3.5.html',
    component: () => import('../zh-CN/changelog/v2.3.5.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.3.6.html',
    component: () => import('../zh-CN/changelog/v2.3.6.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.3.7.html',
    component: () => import('../zh-CN/changelog/v2.3.7.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.3.8.html',
    component: () => import('../zh-CN/changelog/v2.3.8.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.4.0.html',
    component: () => import('../zh-CN/changelog/v2.4.0.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.4.1.html',
    component: () => import('../zh-CN/changelog/v2.4.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.0.html',
    component: () => import('../zh-CN/changelog/v2.5.0.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.1.html',
    component: () => import('../zh-CN/changelog/v2.5.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.10.html',
    component: () => import('../zh-CN/changelog/v2.5.10.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.11.html',
    component: () => import('../zh-CN/changelog/v2.5.11.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.12.html',
    component: () => import('../zh-CN/changelog/v2.5.12.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.2.html',
    component: () => import('../zh-CN/changelog/v2.5.2.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.3.html',
    component: () => import('../zh-CN/changelog/v2.5.3.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.4.html',
    component: () => import('../zh-CN/changelog/v2.5.4.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.5.html',
    component: () => import('../zh-CN/changelog/v2.5.5.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.6.html',
    component: () => import('../zh-CN/changelog/v2.5.6.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.7.html',
    component: () => import('../zh-CN/changelog/v2.5.7.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.8.html',
    component: () => import('../zh-CN/changelog/v2.5.8.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.5.9.html',
    component: () => import('../zh-CN/changelog/v2.5.9.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.6.0.html',
    component: () => import('../zh-CN/changelog/v2.6.0.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.6.1.html',
    component: () => import('../zh-CN/changelog/v2.6.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.6.2.html',
    component: () => import('../zh-CN/changelog/v2.6.2.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.6.3.html',
    component: () => import('../zh-CN/changelog/v2.6.3.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.6.4.html',
    component: () => import('../zh-CN/changelog/v2.6.4.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.6.5.html',
    component: () => import('../zh-CN/changelog/v2.6.5.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.7.0.html',
    component: () => import('../zh-CN/changelog/v2.7.0.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.7.1.html',
    component: () => import('../zh-CN/changelog/v2.7.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.7.2.html',
    component: () => import('../zh-CN/changelog/v2.7.2.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.7.3.html',
    component: () => import('../zh-CN/changelog/v2.7.3.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.7.4.html',
    component: () => import('../zh-CN/changelog/v2.7.4.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.7.5.html',
    component: () => import('../zh-CN/changelog/v2.7.5.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.7.6.html',
    component: () => import('../zh-CN/changelog/v2.7.6.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.7.7.html',
    component: () => import('../zh-CN/changelog/v2.7.7.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.7.8.html',
    component: () => import('../zh-CN/changelog/v2.7.8.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.7.9.html',
    component: () => import('../zh-CN/changelog/v2.7.9.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.8.0.html',
    component: () => import('../zh-CN/changelog/v2.8.0.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.8.1.html',
    component: () => import('../zh-CN/changelog/v2.8.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.9.0.html',
    component: () => import('../zh-CN/changelog/v2.9.0.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.9.1.html',
    component: () => import('../zh-CN/changelog/v2.9.1.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.9.2.html',
    component: () => import('../zh-CN/changelog/v2.9.2.md')
  })
      
  routes.push({
    path: '/zh-CN/changelog/v2.9.4.html',
    component: () => import('../zh-CN/changelog/v2.9.4.md')
  })
      
  routes.push({
    path: '/zh-CN/contribution/donate.html',
    component: () => import('../zh-CN/contribution/donate.md')
  })
      
  routes.push({
    path: '/zh-CN/contribution/issue.html',
    component: () => import('../zh-CN/contribution/issue.md')
  })
      
  routes.push({
    path: '/zh-CN/contribution/pr.html',
    component: () => import('../zh-CN/contribution/pr.md')
  })
      
  routes.push({
    path: '/zh-CN/contribution/vux-development.html',
    component: () => import('../zh-CN/contribution/vux-development.md')
  })
      
  routes.push({
    path: '/zh-CN/css.html',
    component: () => import('../zh-CN/css.md')
  })
      
  routes.push({
    path: '/zh-CN/css/1px.html',
    component: () => import('../zh-CN/css/1px.md')
  })
      
  routes.push({
    path: '/zh-CN/css/close.html',
    component: () => import('../zh-CN/css/close.md')
  })
      
  routes.push({
    path: '/zh-CN/development/i18n.html',
    component: () => import('../zh-CN/development/i18n.md')
  })
      
  routes.push({
    path: '/zh-CN/development/remove-click-delay-fastclick.html',
    component: () => import('../zh-CN/development/remove-click-delay-fastclick.md')
  })
      
  routes.push({
    path: '/zh-CN/development/router.html',
    component: () => import('../zh-CN/development/router.md')
  })
      
  routes.push({
    path: '/zh-CN/development/theme.html',
    component: () => import('../zh-CN/development/theme.md')
  })
      
  routes.push({
    path: '/zh-CN/development/typescript.html',
    component: () => import('../zh-CN/development/typescript.md')
  })
      
  routes.push({
    path: '/zh-CN/development/vue-ajax.html',
    component: () => import('../zh-CN/development/vue-ajax.md')
  })
      
  routes.push({
    path: '/zh-CN/development/vue-global-method.html',
    component: () => import('../zh-CN/development/vue-global-method.md')
  })
      
  routes.push({
    path: '/zh-CN/development/vue-google-analytics.html',
    component: () => import('../zh-CN/development/vue-google-analytics.md')
  })
      
  routes.push({
    path: '/zh-CN/development/vue-loader-autoprefix.html',
    component: () => import('../zh-CN/development/vue-loader-autoprefix.md')
  })
      
  routes.push({
    path: '/zh-CN/development/vue-loader-disable-eslint.html',
    component: () => import('../zh-CN/development/vue-loader-disable-eslint.md')
  })
      
  routes.push({
    path: '/zh-CN/development/vue-router-page-transition.html',
    component: () => import('../zh-CN/development/vue-router-page-transition.md')
  })
      
  routes.push({
    path: '/zh-CN/development/vue-show-loading.html',
    component: () => import('../zh-CN/development/vue-show-loading.md')
  })
      
  routes.push({
    path: '/zh-CN/development/vue-webpack-code-splitting-async.html',
    component: () => import('../zh-CN/development/vue-webpack-code-splitting-async.md')
  })
      
  routes.push({
    path: '/zh-CN/development/vue-webpack-env.html',
    component: () => import('../zh-CN/development/vue-webpack-env.md')
  })
      
  routes.push({
    path: '/zh-CN/development/vux-nuxt-ssr.html',
    component: () => import('../zh-CN/development/vux-nuxt-ssr.md')
  })
      
  routes.push({
    path: '/zh-CN/directives/v-transfer-dom.html',
    component: () => import('../zh-CN/directives/v-transfer-dom.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/$t-is-not-defined.html',
    component: () => import('../zh-CN/faq/$t-is-not-defined.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/can-vux-used-in-weapp.html',
    component: () => import('../zh-CN/faq/can-vux-used-in-weapp.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/cannot-resolve-inline-desc.html',
    component: () => import('../zh-CN/faq/cannot-resolve-inline-desc.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/difference-between-vux-template-and-webpack-template.html',
    component: () => import('../zh-CN/faq/difference-between-vux-template-and-webpack-template.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/document-framework.html',
    component: () => import('../zh-CN/faq/document-framework.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/does-vux-support-weex.html',
    component: () => import('../zh-CN/faq/does-vux-support-weex.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/dupicate-style.html',
    component: () => import('../zh-CN/faq/dupicate-style.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/index.html',
    component: () => import('../zh-CN/faq/index.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/is-vux-wechat-official-project.html',
    component: () => import('../zh-CN/faq/is-vux-wechat-official-project.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/Uncaught-SyntaxError-Unexpected-token-export.html',
    component: () => import('../zh-CN/faq/Uncaught-SyntaxError-Unexpected-token-export.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/vux-build-issue.html',
    component: () => import('../zh-CN/faq/vux-build-issue.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/vux-server-render-support.html',
    component: () => import('../zh-CN/faq/vux-server-render-support.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/what-is-vux-virtual-component.html',
    component: () => import('../zh-CN/faq/what-is-vux-virtual-component.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/why-cannot-i-import-all-components.html',
    component: () => import('../zh-CN/faq/why-cannot-i-import-all-components.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/why-cannot-i-use-vux-with-cdn.html',
    component: () => import('../zh-CN/faq/why-cannot-i-use-vux-with-cdn.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/why-close-my-issue.html',
    component: () => import('../zh-CN/faq/why-close-my-issue.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/why-delete-my-issue-comment.html',
    component: () => import('../zh-CN/faq/why-delete-my-issue-comment.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/why-use-vue-file-for-distribution.html',
    component: () => import('../zh-CN/faq/why-use-vue-file-for-distribution.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/why-use-x-prefix-for-components.html',
    component: () => import('../zh-CN/faq/why-use-x-prefix-for-components.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/why-using-vux-loader.html',
    component: () => import('../zh-CN/faq/why-using-vux-loader.md')
  })
      
  routes.push({
    path: '/zh-CN/faq/will-vux-stop-maintaining.html',
    component: () => import('../zh-CN/faq/will-vux-stop-maintaining.md')
  })
      
  routes.push({
    path: '/zh-CN/install/biolerplate.html',
    component: () => import('../zh-CN/install/biolerplate.md')
  })
      
  routes.push({
    path: '/zh-CN/install/manual-usage.html',
    component: () => import('../zh-CN/install/manual-usage.md')
  })
      
  routes.push({
    path: '/zh-CN/install/npm.html',
    component: () => import('../zh-CN/install/npm.md')
  })
      
  routes.push({
    path: '/zh-CN/install/umd.html',
    component: () => import('../zh-CN/install/umd.md')
  })
      
  routes.push({
    path: '/zh-CN/install/upgrade-to-vux2.html',
    component: () => import('../zh-CN/install/upgrade-to-vux2.md')
  })
      
  routes.push({
    path: '/zh-CN/install/usage.html',
    component: () => import('../zh-CN/install/usage.md')
  })
      
  routes.push({
    path: '/zh-CN/lab/index.html',
    component: () => import('../zh-CN/lab/index.md')
  })
      
  routes.push({
    path: '/zh-CN/production/inline-manifest.html',
    component: () => import('../zh-CN/production/inline-manifest.md')
  })
      
  routes.push({
    path: '/zh-CN/README.html',
    component: () => import('../zh-CN/README.md')
  })
      
  routes.push({
    path: '/zh-CN/tools/base64.html',
    component: () => import('../zh-CN/tools/base64.md')
  })
      
  routes.push({
    path: '/zh-CN/tools/cookie.html',
    component: () => import('../zh-CN/tools/cookie.md')
  })
      
  routes.push({
    path: '/zh-CN/tools/date.html',
    component: () => import('../zh-CN/tools/date.md')
  })
      
  routes.push({
    path: '/zh-CN/tools/debounce-throttle.html',
    component: () => import('../zh-CN/tools/debounce-throttle.md')
  })
      
  routes.push({
    path: '/zh-CN/tools/md5.html',
    component: () => import('../zh-CN/tools/md5.md')
  })
      
  routes.push({
    path: '/zh-CN/tools/number.html',
    component: () => import('../zh-CN/tools/number.md')
  })
      
  routes.push({
    path: '/zh-CN/tools/querystring.html',
    component: () => import('../zh-CN/tools/querystring.md')
  })
      
  routes.push({
    path: '/zh-CN/tools/string.html',
    component: () => import('../zh-CN/tools/string.md')
  })
      
  routes.push({
    path: '/zh-CN/umd.html',
    component: () => import('../zh-CN/umd.md')
  })
      
  routes.push({
    path: '/zh-CN/upgrade-to-2.html',
    component: () => import('../zh-CN/upgrade-to-2.md')
  })
      
  routes.push({
    path: '/zh-CN/vux-loader.html',
    component: () => import('../zh-CN/vux-loader.md')
  })
      
  routes.push({
    path: '/zh-CN/vux-loader/about.html',
    component: () => import('../zh-CN/vux-loader/about.md')
  })
      
  routes.push({
    path: '/zh-CN/vux-loader/how-vux-loader-works.html',
    component: () => import('../zh-CN/vux-loader/how-vux-loader-works.md')
  })
      
  routes.push({
    path: '/zh-CN/vux-loader/install.html',
    component: () => import('../zh-CN/vux-loader/install.md')
  })
      
  routes.push({
    path: '/zh-CN/vux-loader/plugins.html',
    component: () => import('../zh-CN/vux-loader/plugins.md')
  })
      
  routes.push({
    path: '/zh-CN/wechat/other.html',
    component: () => import('../zh-CN/wechat/other.md')
  })
      
  routes.push({
    path: '/zh-CN/wechat/vue-wechat-jssdk.html',
    component: () => import('../zh-CN/wechat/vue-wechat-jssdk.md')
  })
      
  routes.push({
    path: '/zh-CN/wechat/wechat-document-title.html',
    component: () => import('../zh-CN/wechat/wechat-document-title.md')
  })
      
    routes.push({
      path: '/en/components/actionsheet.html',
      component: () => import('../en/components/actionsheet.vue')
    })
        
    routes.push({
      path: '/en/components/alert.html',
      component: () => import('../en/components/alert.vue')
    })
        
    routes.push({
      path: '/en/components/badge.html',
      component: () => import('../en/components/badge.vue')
    })
        
    routes.push({
      path: '/en/components/blur.html',
      component: () => import('../en/components/blur.vue')
    })
        
    routes.push({
      path: '/en/components/box.html',
      component: () => import('../en/components/box.vue')
    })
        
    routes.push({
      path: '/en/components/button-tab.html',
      component: () => import('../en/components/button-tab.vue')
    })
        
    routes.push({
      path: '/en/components/calendar.html',
      component: () => import('../en/components/calendar.vue')
    })
        
    routes.push({
      path: '/en/components/card.html',
      component: () => import('../en/components/card.vue')
    })
        
    routes.push({
      path: '/en/components/cell-box.html',
      component: () => import('../en/components/cell-box.vue')
    })
        
    routes.push({
      path: '/en/components/cell-form-preview.html',
      component: () => import('../en/components/cell-form-preview.vue')
    })
        
    routes.push({
      path: '/en/components/cell.html',
      component: () => import('../en/components/cell.vue')
    })
        
    routes.push({
      path: '/en/components/check-icon.html',
      component: () => import('../en/components/check-icon.vue')
    })
        
    routes.push({
      path: '/en/components/checker.html',
      component: () => import('../en/components/checker.vue')
    })
        
    routes.push({
      path: '/en/components/checklist.html',
      component: () => import('../en/components/checklist.vue')
    })
        
    routes.push({
      path: '/en/components/clocker.html',
      component: () => import('../en/components/clocker.vue')
    })
        
    routes.push({
      path: '/en/components/color-picker.html',
      component: () => import('../en/components/color-picker.vue')
    })
        
    routes.push({
      path: '/en/components/confirm.html',
      component: () => import('../en/components/confirm.vue')
    })
        
    routes.push({
      path: '/en/components/countdown.html',
      component: () => import('../en/components/countdown.vue')
    })
        
    routes.push({
      path: '/en/components/countup.html',
      component: () => import('../en/components/countup.vue')
    })
        
    routes.push({
      path: '/en/components/datetime-range.html',
      component: () => import('../en/components/datetime-range.vue')
    })
        
    routes.push({
      path: '/en/components/datetime-view.html',
      component: () => import('../en/components/datetime-view.vue')
    })
        
    routes.push({
      path: '/en/components/datetime.html',
      component: () => import('../en/components/datetime.vue')
    })
        
    routes.push({
      path: '/en/components/divider.html',
      component: () => import('../en/components/divider.vue')
    })
        
    routes.push({
      path: '/en/components/drawer.html',
      component: () => import('../en/components/drawer.vue')
    })
        
    routes.push({
      path: '/en/components/flexbox.html',
      component: () => import('../en/components/flexbox.vue')
    })
        
    routes.push({
      path: '/en/components/flow.html',
      component: () => import('../en/components/flow.vue')
    })
        
    routes.push({
      path: '/en/components/form-preview.html',
      component: () => import('../en/components/form-preview.vue')
    })
        
    routes.push({
      path: '/en/components/grid.html',
      component: () => import('../en/components/grid.vue')
    })
        
    routes.push({
      path: '/en/components/group.html',
      component: () => import('../en/components/group.vue')
    })
        
    routes.push({
      path: '/en/components/icon.html',
      component: () => import('../en/components/icon.vue')
    })
        
    routes.push({
      path: '/en/components/inline-calendar.html',
      component: () => import('../en/components/inline-calendar.vue')
    })
        
    routes.push({
      path: '/en/components/inline-desc.html',
      component: () => import('../en/components/inline-desc.vue')
    })
        
    routes.push({
      path: '/en/components/inline-loading.html',
      component: () => import('../en/components/inline-loading.vue')
    })
        
    routes.push({
      path: '/en/components/inline-x-number.html',
      component: () => import('../en/components/inline-x-number.vue')
    })
        
    routes.push({
      path: '/en/components/inline-x-switch.html',
      component: () => import('../en/components/inline-x-switch.vue')
    })
        
    routes.push({
      path: '/en/components/load-more.html',
      component: () => import('../en/components/load-more.vue')
    })
        
    routes.push({
      path: '/en/components/loading.html',
      component: () => import('../en/components/loading.vue')
    })
        
    routes.push({
      path: '/en/components/marquee.html',
      component: () => import('../en/components/marquee.vue')
    })
        
    routes.push({
      path: '/en/components/masker.html',
      component: () => import('../en/components/masker.vue')
    })
        
    routes.push({
      path: '/en/components/msg.html',
      component: () => import('../en/components/msg.vue')
    })
        
    routes.push({
      path: '/en/components/panel.html',
      component: () => import('../en/components/panel.vue')
    })
        
    routes.push({
      path: '/en/components/picker.html',
      component: () => import('../en/components/picker.vue')
    })
        
    routes.push({
      path: '/en/components/popover.html',
      component: () => import('../en/components/popover.vue')
    })
        
    routes.push({
      path: '/en/components/popup-header.html',
      component: () => import('../en/components/popup-header.vue')
    })
        
    routes.push({
      path: '/en/components/popup-picker.html',
      component: () => import('../en/components/popup-picker.vue')
    })
        
    routes.push({
      path: '/en/components/popup-radio.html',
      component: () => import('../en/components/popup-radio.vue')
    })
        
    routes.push({
      path: '/en/components/popup.html',
      component: () => import('../en/components/popup.vue')
    })
        
    routes.push({
      path: '/en/components/previewer.html',
      component: () => import('../en/components/previewer.vue')
    })
        
    routes.push({
      path: '/en/components/qrcode.html',
      component: () => import('../en/components/qrcode.vue')
    })
        
    routes.push({
      path: '/en/components/radio.html',
      component: () => import('../en/components/radio.vue')
    })
        
    routes.push({
      path: '/en/components/range.html',
      component: () => import('../en/components/range.vue')
    })
        
    routes.push({
      path: '/en/components/rater.html',
      component: () => import('../en/components/rater.vue')
    })
        
    routes.push({
      path: '/en/components/scroller.html',
      component: () => import('../en/components/scroller.vue')
    })
        
    routes.push({
      path: '/en/components/search.html',
      component: () => import('../en/components/search.vue')
    })
        
    routes.push({
      path: '/en/components/selector.html',
      component: () => import('../en/components/selector.vue')
    })
        
    routes.push({
      path: '/en/components/spinner.html',
      component: () => import('../en/components/spinner.vue')
    })
        
    routes.push({
      path: '/en/components/step.html',
      component: () => import('../en/components/step.vue')
    })
        
    routes.push({
      path: '/en/components/sticky.html',
      component: () => import('../en/components/sticky.vue')
    })
        
    routes.push({
      path: '/en/components/swipeout.html',
      component: () => import('../en/components/swipeout.vue')
    })
        
    routes.push({
      path: '/en/components/swiper.html',
      component: () => import('../en/components/swiper.vue')
    })
        
    routes.push({
      path: '/en/components/tab.html',
      component: () => import('../en/components/tab.vue')
    })
        
    routes.push({
      path: '/en/components/tabbar.html',
      component: () => import('../en/components/tabbar.vue')
    })
        
    routes.push({
      path: '/en/components/timeline.html',
      component: () => import('../en/components/timeline.vue')
    })
        
    routes.push({
      path: '/en/components/toast.html',
      component: () => import('../en/components/toast.vue')
    })
        
    routes.push({
      path: '/en/components/uploader.html',
      component: () => import('../en/components/uploader.vue')
    })
        
    routes.push({
      path: '/en/components/v-chart.html',
      component: () => import('../en/components/v-chart.vue')
    })
        
    routes.push({
      path: '/en/components/view-box.html',
      component: () => import('../en/components/view-box.vue')
    })
        
    routes.push({
      path: '/en/components/wechat-emotion.html',
      component: () => import('../en/components/wechat-emotion.vue')
    })
        
    routes.push({
      path: '/en/components/x-address.html',
      component: () => import('../en/components/x-address.vue')
    })
        
    routes.push({
      path: '/en/components/x-button.html',
      component: () => import('../en/components/x-button.vue')
    })
        
    routes.push({
      path: '/en/components/x-circle.html',
      component: () => import('../en/components/x-circle.vue')
    })
        
    routes.push({
      path: '/en/components/x-dialog.html',
      component: () => import('../en/components/x-dialog.vue')
    })
        
    routes.push({
      path: '/en/components/x-form.html',
      component: () => import('../en/components/x-form.vue')
    })
        
    routes.push({
      path: '/en/components/x-header.html',
      component: () => import('../en/components/x-header.vue')
    })
        
    routes.push({
      path: '/en/components/x-icon.html',
      component: () => import('../en/components/x-icon.vue')
    })
        
    routes.push({
      path: '/en/components/x-img.html',
      component: () => import('../en/components/x-img.vue')
    })
        
    routes.push({
      path: '/en/components/x-input.html',
      component: () => import('../en/components/x-input.vue')
    })
        
    routes.push({
      path: '/en/components/x-number.html',
      component: () => import('../en/components/x-number.vue')
    })
        
    routes.push({
      path: '/en/components/x-progress.html',
      component: () => import('../en/components/x-progress.vue')
    })
        
    routes.push({
      path: '/en/components/x-switch.html',
      component: () => import('../en/components/x-switch.vue')
    })
        
    routes.push({
      path: '/en/components/x-table.html',
      component: () => import('../en/components/x-table.vue')
    })
        
    routes.push({
      path: '/en/components/x-textarea.html',
      component: () => import('../en/components/x-textarea.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/actionsheet.html',
      component: () => import('../zh-CN/components/actionsheet.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/alert.html',
      component: () => import('../zh-CN/components/alert.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/badge.html',
      component: () => import('../zh-CN/components/badge.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/blur.html',
      component: () => import('../zh-CN/components/blur.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/box.html',
      component: () => import('../zh-CN/components/box.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/button-tab.html',
      component: () => import('../zh-CN/components/button-tab.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/calendar.html',
      component: () => import('../zh-CN/components/calendar.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/card.html',
      component: () => import('../zh-CN/components/card.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/cell-box.html',
      component: () => import('../zh-CN/components/cell-box.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/cell-form-preview.html',
      component: () => import('../zh-CN/components/cell-form-preview.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/cell.html',
      component: () => import('../zh-CN/components/cell.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/check-icon.html',
      component: () => import('../zh-CN/components/check-icon.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/checker.html',
      component: () => import('../zh-CN/components/checker.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/checklist.html',
      component: () => import('../zh-CN/components/checklist.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/clocker.html',
      component: () => import('../zh-CN/components/clocker.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/color-picker.html',
      component: () => import('../zh-CN/components/color-picker.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/confirm.html',
      component: () => import('../zh-CN/components/confirm.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/countdown.html',
      component: () => import('../zh-CN/components/countdown.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/countup.html',
      component: () => import('../zh-CN/components/countup.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/datetime-range.html',
      component: () => import('../zh-CN/components/datetime-range.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/datetime-view.html',
      component: () => import('../zh-CN/components/datetime-view.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/datetime.html',
      component: () => import('../zh-CN/components/datetime.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/divider.html',
      component: () => import('../zh-CN/components/divider.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/drawer.html',
      component: () => import('../zh-CN/components/drawer.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/flexbox.html',
      component: () => import('../zh-CN/components/flexbox.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/flow.html',
      component: () => import('../zh-CN/components/flow.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/form-preview.html',
      component: () => import('../zh-CN/components/form-preview.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/grid.html',
      component: () => import('../zh-CN/components/grid.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/group.html',
      component: () => import('../zh-CN/components/group.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/icon.html',
      component: () => import('../zh-CN/components/icon.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/inline-calendar.html',
      component: () => import('../zh-CN/components/inline-calendar.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/inline-desc.html',
      component: () => import('../zh-CN/components/inline-desc.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/inline-loading.html',
      component: () => import('../zh-CN/components/inline-loading.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/inline-x-number.html',
      component: () => import('../zh-CN/components/inline-x-number.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/inline-x-switch.html',
      component: () => import('../zh-CN/components/inline-x-switch.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/load-more.html',
      component: () => import('../zh-CN/components/load-more.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/loading.html',
      component: () => import('../zh-CN/components/loading.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/marquee.html',
      component: () => import('../zh-CN/components/marquee.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/masker.html',
      component: () => import('../zh-CN/components/masker.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/msg.html',
      component: () => import('../zh-CN/components/msg.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/panel.html',
      component: () => import('../zh-CN/components/panel.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/picker.html',
      component: () => import('../zh-CN/components/picker.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/popover.html',
      component: () => import('../zh-CN/components/popover.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/popup-header.html',
      component: () => import('../zh-CN/components/popup-header.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/popup-picker.html',
      component: () => import('../zh-CN/components/popup-picker.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/popup-radio.html',
      component: () => import('../zh-CN/components/popup-radio.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/popup.html',
      component: () => import('../zh-CN/components/popup.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/previewer.html',
      component: () => import('../zh-CN/components/previewer.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/qrcode.html',
      component: () => import('../zh-CN/components/qrcode.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/radio.html',
      component: () => import('../zh-CN/components/radio.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/range.html',
      component: () => import('../zh-CN/components/range.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/rater.html',
      component: () => import('../zh-CN/components/rater.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/scroller.html',
      component: () => import('../zh-CN/components/scroller.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/search.html',
      component: () => import('../zh-CN/components/search.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/selector.html',
      component: () => import('../zh-CN/components/selector.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/spinner.html',
      component: () => import('../zh-CN/components/spinner.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/step.html',
      component: () => import('../zh-CN/components/step.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/sticky.html',
      component: () => import('../zh-CN/components/sticky.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/swipeout.html',
      component: () => import('../zh-CN/components/swipeout.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/swiper.html',
      component: () => import('../zh-CN/components/swiper.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/tab.html',
      component: () => import('../zh-CN/components/tab.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/tabbar.html',
      component: () => import('../zh-CN/components/tabbar.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/timeline.html',
      component: () => import('../zh-CN/components/timeline.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/toast.html',
      component: () => import('../zh-CN/components/toast.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/uploader.html',
      component: () => import('../zh-CN/components/uploader.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/v-chart.html',
      component: () => import('../zh-CN/components/v-chart.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/view-box.html',
      component: () => import('../zh-CN/components/view-box.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/wechat-emotion.html',
      component: () => import('../zh-CN/components/wechat-emotion.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-address.html',
      component: () => import('../zh-CN/components/x-address.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-button.html',
      component: () => import('../zh-CN/components/x-button.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-circle.html',
      component: () => import('../zh-CN/components/x-circle.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-dialog.html',
      component: () => import('../zh-CN/components/x-dialog.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-form.html',
      component: () => import('../zh-CN/components/x-form.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-header.html',
      component: () => import('../zh-CN/components/x-header.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-icon.html',
      component: () => import('../zh-CN/components/x-icon.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-img.html',
      component: () => import('../zh-CN/components/x-img.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-input.html',
      component: () => import('../zh-CN/components/x-input.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-number.html',
      component: () => import('../zh-CN/components/x-number.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-progress.html',
      component: () => import('../zh-CN/components/x-progress.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-switch.html',
      component: () => import('../zh-CN/components/x-switch.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-table.html',
      component: () => import('../zh-CN/components/x-table.vue')
    })
        
    routes.push({
      path: '/zh-CN/components/x-textarea.html',
      component: () => import('../zh-CN/components/x-textarea.vue')
    })
        
routes.push({
  path: '*',
  component: () => import('../404.md')
})


Vue.use(Router)

const createRouter = () => {
  const router = new Router({
    mode: 'history',
    routes
  })

  if (__BROWSER__) {
    const nprogress = require('nprogress')
    require('nprogress/nprogress.css')

    // if (process.env.NODE_ENV === 'production') {
    //   ;
    //   (function (i, s, o, g, r, a, m) {
    //     i['GoogleAnalyticsObject'] = r;
    //     i[r] = i[r] || function () {
    //       (i[r].q = i[r].q || []).push(arguments)
    //     }, i[r].l = 1 * new Date();
    //     a = s.createElement(o),
    //       m = s.getElementsByTagName(o)[0];
    //     a.async = 1;
    //     a.src = g;
    //     m.parentNode.insertBefore(a, m)
    //   })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

    //   ga('create', 'UA-89859411-2', 'auto');
    //   ga('send', 'pageview');

    //   router.afterEach(function (to) {
    //     ga('set', 'page', to.fullPath);
    //     ga('send', 'pageview');
    //   })
    // }

    router.beforeEach((from, to, next) => {
      nprogress.start()
      next()
    })
    router.afterEach(() => {
      nprogress.done()
      window.scrollTo(0, 0)
    })
  }

  return router
}

export default {
  createRouter,
  createStore,
  App
}



// WEBPACK FOOTER //
// ./src/_index.js